import React from "react"

const IconContainer = (svg, width = 100, height = 100) => <img key={`${svg}-${width}-${height}`} src={svg} width={width} height={height} />

export default IconContainer
